module.exports = __webpack_public_path__ + "img/xqtx-logo-icon.36675130.png";